module.exports = __webpack_public_path__ + "img/home-popup-top.5ff808d1.png";